import { useFeatureFlagEnabled } from "posthog-js/react";
import { getAccountData, isAdmin } from "@/hooks/query/useAccount";
import { useSiteState } from "@/hooks/query/useSite";
import useRenderer from "./query/useRenderer";

const DEV_USER = "localbox@showit.com";

/**
 * Returns user's email if set. Probably temporary for local dev, but could be useful if we set env version (probably "local")
 * @returns {string=}
 */
const getUserEmail = () => getAccountData()?.email;

/**
 * Gates a feature to v2 designs (past the renderer cutoff). Without a flag every user
 * on a v2 design qualifies; with a flag the user must also be dev, admin, or have it.
 * @param {string} [flag] PostHog flag to check.
 * @returns {boolean}
 */
const useV2Feature = (flag) => {
  const siteId = useSiteState().get("site_design_id");
  const enabled = useFeatureFlagEnabled(flag ?? "");
  const { canToggle, settled } = useRenderer(siteId);

  if (!settled || canToggle) return false;
  if (!flag) return true;
  return getUserEmail() === DEV_USER || isAdmin() || enabled === true;
};

export default useV2Feature;
